import { SOFTWARE_MNG } from '@/api/apiModules'
export default {
  viewType: 'form',
  module: SOFTWARE_MNG,
  params: null,
  view: {
    class: '',
    title: '创建软件',
    labelPosition: 'right',
    content: [
      {
        $id: 'softwareName',
        $type: 'input',
        label: '软件名',
        rules: [
          {
            notEmpty: '软件名'
          }
        ]
      },
      {
        $id: 'softwareVersion',
        $type: 'input',
        label: '软件版本',
        rules: [
          {
            notEmpty: '软件版本'
          }
        ]
      },
      {
        $id: 'publisher',
        $type: 'input',
        label: '发布者',
        rules: [
          {
            notEmpty: '发布者'
          }
        ]
      },
      {
        $id: 'specSoftwareConfigDTOList',
        $type: 'sky-product-os-relate',
        label: '支持的产品及操作系统',
        rules: [
          {
            //notEmpty: '支持的产品及操作系统'
          }
        ]
      }
    ]
  }
}
